var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[_c('div',{staticClass:"aside-top"},[_vm._t("header")],2),_vm._t("default"),_c('v-flex'),_vm._t("footer")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }